(() => {
  const locale = (document.documentElement.lang || 'fr').toLowerCase().split('-')[0];
  if (locale !== 'en') return;

  const textMap = new Map([
    ['Cette page s’est fanée.', 'This page has faded away.'],
    ['Le lien n’existe plus ou a été déplacé. Retrouvez les créations Flowever.', 'The link no longer exists or has moved. Discover Flowever’s creations.'],
    ['Découvrir les bouquets', 'Discover the bouquets']
  ]);

  const translate = () => {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const raw = node.nodeValue;
      const trimmed = raw.trim();
      if (!trimmed || !textMap.has(trimmed)) continue;
      node.nodeValue = raw.replace(trimmed, textMap.get(trimmed));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translate, { once: true });
  } else {
    translate();
  }
})();
